<template>
  <div class="content-right-route-lists">
    <div  class="content-right-route-list"  v-for="(item,index) in sidelists" :key="index" @click = goto(item)  >
      <div class="content-right-route-list-left">
        <img :src="item.faceimg" alt="">
      </div>
      <div class="content-right-route-list-right">
        <div style="font-size:16px;font-weight:400;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">{{item.title}}</div>
        <div class="content-right-route-list-right-second">{{item.introduce}}</div>
        <div class="content-right-route-list-right-third">
          <div style="color:#9ca5ab;font-size:14px;"><img src="../static/images/eye.jpg" alt=""><span class='mg'>{{item.visitornum}}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sidelists: {
      default: () => {
        return []
      },
      type: Array,
      required: true
    }
  },
  methods: {
    goto (item) {
      this.reload()
      this.$router.push({
        name: 'PastReviewDetail',
        query: {
          id: item.id,
          img: item.faceimg,
          title: item.title
        }
      })
    }
  }
}
</script>

<style scoped>
.content-right-route-list {
  display: flex;
  padding: 20px 0;
  border-bottom: 1px solid #f4f4f4;
  cursor: pointer;
}
.content-right-route-list-left {
  width: 140px;
  height: 90px;
  margin-right: 10px;
}
.content-right-route-list-left img {
  width: 100%;
  height: 100%;
}
.content-right-route-list-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 140px;
}
.content-right-route-list-right-second {
  font-size: 14px;
  color: #9ca5ab;
  text-overflow: ellipsis;
  overflow: hidden;
  display:-webkit-box;
-webkit-line-clamp:2;
-webkit-box-orient:vertical;
}
.content-right-route-list-right-third {
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mg{
  margin-left:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ListsContent2.vue